import axios from 'axios';

export default class PreviewService
{
    public static async getPreviewToken()
    {
        return (await axios.get<string>('admin/cms/preview/token', {
            withCredentials: true
        })).data;
    }
}
